export type VisibilityId = ['visibility_id', number];
export const VisibilityId = (visibilityId: number): VisibilityId => [
  'visibility_id',
  visibilityId,
];

export type VisibilityMeta = {
  overview: boolean;
  financials: true;
  projectPlan: boolean;
  spaces: boolean;
  chat: boolean;
  statusUpdates: boolean;
  list: boolean;
  board: boolean;
  form: boolean;
  files: boolean;
  projectHoursToggle?: boolean;
};

export type BaseVisibilitySkelton = {
  visibilityMeta: VisibilityMeta;
};

export interface AccountVisibility extends BaseVisibilitySkelton {
  visibilityId: number;
}

export interface ProjectVisibility extends BaseVisibilitySkelton {
  projectId: number;
  visibilityId: number;
}

export type Visibility = AccountVisibility | ProjectVisibility;
